import { useState, useCallback } from 'react';
import { ANALYTICS_DATE_PRESETS, DEFAULT_DATE_PRESET } from '../configs/analytics.config';

const useAnalyticsDateRange = () => {
  const [rangeKey, setRangeKey] = useState(DEFAULT_DATE_PRESET);
  const [dateRange, setDateRange] = useState(() => ANALYTICS_DATE_PRESETS[DEFAULT_DATE_PRESET]());

  const handlePresetChange = useCallback((key) => {
    const presetFn = ANALYTICS_DATE_PRESETS[key];
    if (presetFn) {
      setDateRange(presetFn());
      setRangeKey(key);
    }
  }, []);

  const handleCustomRange = useCallback((dates) => {
    if (dates && dates.length === 2) {
      setDateRange(dates);
      setRangeKey('Custom');
    }
  }, []);

  return {
    dateRange,
    rangeKey,
    setRangeKey,
    setDateRange,
    handlePresetChange,
    handleCustomRange,
  };
};

export default useAnalyticsDateRange;
